<template>
  <DropDownAbsolute :value="showDropDown" @input="$event ? openDropDown() : hideDropDown()">
    <div class="hvh-flex wrap">
      <div class="hvh-flex wrap overflow-hidden grow-1">
        <DPDPill
          class="pill not-clickable pt-2"
          :label="item.fullItem || item.item"
          :type="item.prop"
          :title="item.title"
          :isLoading="isFiltering"
          @[removeProp(item)]="callRemove(item.remove)"
          v-for="item in ribonItems"
          :key="item.title + ':' + item.item"
        />
        <v-btn flat class="hvh-btn--secondary button ml-0" @click="$emit('reset')" v-if="showReset">Reset</v-btn>
        <v-btn flat class="hvh-btn--secondary button ml-0" @click="clearAll" v-if="showClearAll">Clear all</v-btn>

        <DPDSingleSelectInput class="grow-1" v-model="searchWord" :style="inputStyle" @input="openDropDown" @paste="searchPasted" @click.stop="openDropDown" @focus="openDropDown" @keydown.esc="escape" placeholder="ADD FILTER" ref="input" />
      </div>
    </div>
    <template #drop-down>
      <DPDSearchSingleTree :searchWord="searchWord" :categorySetting="categorySetting" :data="data" @update:data="updateData" @input="add" />
    </template>
  </DropDownAbsolute>
</template>

<script>
import { getTextWidth, hashCode, isObject } from '../../../libraries/common';
import { getFilterItems, getRibonItems, topEvents } from '../../../libraries/liveFilters';
import DPDPill from '../../analytics/cohorts/DPDPill.vue';
import DropDownAbsolute from '../../common/dropDown/DropDownAbsolute.vue';
import DPDSearchSingleTree from '../../common/drugProdSelect/dpdSelect/DPDSearchSingleTree.vue';
import DPDSingleSelectInput from '../../common/drugProdSelect/dpdSelect/DPDSingleSelectInput.vue';

export default {
  components: { DPDPill, DPDSingleSelectInput, DropDownAbsolute, DPDSearchSingleTree },
  props: ['value', 'segment', 'isFiltering'],
  data() {
    return {
      categorySetting: {
        drug: true,
        diagnose: true,
        procedure: true,
        physician: false,
        cohort: false,
      },
      selectedTreeElements: [],
      searchWord: null,
      searchLastLevelTypes: ['drugbrand', 'dxname', 'procdescrip'],
      inputFont: null,
      showDropDown: false,
      data: null,
    }
  },
  computed: {
    ribonItems() {
      return getRibonItems(this.value, this.segment);
    },
    showClearAll() {
      return (this.ribonItems || []).filter(f => f.remove).length > 1;
    },
    showReset() {
      if (false) { // eslint-disable-line  
        // #DAS-129
        return hashCode(getFilterItems(this.value)) !== this.value.hashCode();
      }
      return false;
    },
    inputStyle() {
      var textWidth = getTextWidth(this.inputFont)(this.searchWord || '');
      return { width: `${textWidth + 100}px` };
    },
  },
  methods: {
    removeProp(item) {
      return item.remove ? 'remove' : null;
    },
    callRemove(removeFnc) {
      removeFnc.call(this);
    },
    clearAll() {
      this.$confirm('Remove all filters', 'You are about to remove all filters.\n\nThis action cannot be undone. Do you still want to continue?')
        .then(() => {
          var eventer = {
            value: { ...this.value },
            segment: this.segment,
            events: {},
            translation: this.value.translation,
            $emit: (event, ...args) => event === 'input' ? eventer.value = args[0] : eventer.events[event] = args,
          }
          this.ribonItems
            .filter(f => f.remove)
            .forEach(f => f.remove.call(eventer));

          Object.keys(eventer.events)
            .forEach(key => this.$emit(key, ...(eventer.events[key].args || [])));
          this.$emit('input', eventer.value);
        }).catch(() => null);
    },
    add(event) {
      var events = Object.entries(topEvents)
        .reduce((acc, [key, event]) => { acc[event.prop] = key; return acc; }, {});

      var filters = { ...this.value };
      var key = events[event.type.toLowerCase()];
      if (key)
        filters[key] = (filters[key] || []).toggle(event.label, true);

      this.$emit('input', filters);
      this.hideDropDown();
    },
    openDropDown() {
      this.showDropDown = true;
    },
    hideDropDown() {
      this.searchWord = null;
      this.data = null;
      this.showDropDown = false;
    },
    searchPasted(event) {
      if (!isObject(event))
        this.searchWord = event;
    },
    escape() {
      if (this.showDropDown) {
        if (this.searchWord) {
          this.searchWord = null;
          this.data = null;
        } else {
          this.hideDropDown();
        }
      }
    },
    updateData(data) {
      this.data = data?.filter(f => f.item.id !== 'searchWord')
        .forEach(f => {
          f.stateId = data.find(g => g.item === f.item).stateId;

          var isLastLevelType = this.searchLastLevelTypes.includes(f.item.type?.toLowerCase());
          if (isLastLevelType) {
            f.item.children = [];
            f.children = [];
          }
        });
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisLiveFiltersRibbon'] = this;

    this.inputFont = getComputedStyle(this.$refs.input.$el).font;
  }
}
</script>

<style lang="scss" scoped>
.button {
  border-radius: 28px;
  color: #195d6f;
}
</style>
